/* eslint-disable */
import axios from "axios";
import {
  API,
  SEARCH_ALL_PATH,
  ALL,
  SEARCH_ARTICLES_PATH,
  SEARCH_PROJECTS_PATH,
  SEARCH_PRODUCTS_PATH,
  SEARCH_IMAGES_PATH,
  SEARCH_PROFESSIONALS_PATH,
  WIDGETS_PATH,
  SEARCH_QUERY,
  MYAD_FOLDER_IMAGES,
  MYAD_FOLDER_PER_PAGE,
  SEARCH_CACHED_FOLDERS_PATH,
  EMPTY_OBJECT,
  MAX_CACHED_PAGES,
  PROJECTS,
  ARTICLE_ARCHIVE_PATH
} from "../utils/constants";
import { getQueryStrings } from '../helpers/common'

const routeScopeFor = ({ scope, site }) => scope || site

const createUrl = (params, path) => {
  const { query, filters = '',  page = '', lastParent = '', sort } = params
  const queryStrings = getQueryStrings(query, page, sort)
  return `${API}/${routeScopeFor(params)}${path}${filters}${queryStrings}${lastParent}`
}

const requestWithFilters = async (urlParams, callback, searchType) => {
  try {
    const url = createUrl(urlParams, searchType)
    const response = await fetch(url)
    const { aggregations, total_docs, results, results_grouped, recommended_results,
      main_aggregations, static_data, metadata = {}, sponsored_content = [] } = await response.json()
    const offices = aggregations && aggregations.hasOwnProperty('offices') ? aggregations.offices.slice(0, 15) : []
    const state = {
      aggregations: main_aggregations,
      filters: aggregations,
      totalDocs: total_docs,
      results,
      resultsGrouped: results_grouped,
      recommendedResults: recommended_results ?? [],
      resultsAreLoading: false,
      offices,
      staticData: static_data,
      hasMore: results.length === 18,
      metadata,
      sponsoredContent: sponsored_content
    }
    callback(state)
  } catch (error) {
    console.error('Error', error)
    const newState = {
      error: true,
      resultsAreLoading: false
    };
    callback(newState);
  }
}

export const requestProjects = async (urlParams, callback) => requestWithFilters(urlParams, callback, SEARCH_PROJECTS_PATH)
export const requestProducts = async (urlParams, callback) => requestWithFilters(urlParams, callback, SEARCH_PRODUCTS_PATH)
export const requestMedias = async (urlParams, callback) => requestWithFilters(urlParams, callback, SEARCH_IMAGES_PATH)
export const requestProfessionals = async (urlParams, callback) => requestWithFilters(urlParams, callback, SEARCH_PROFESSIONALS_PATH)
export const requestArchiveArticles = async (urlParams, callback) => requestWithFilters(urlParams, callback, ARTICLE_ARCHIVE_PATH)

export const requestAll = (urlParams, callback) => {
  const { query, page } = urlParams;
  const pageString = !!page ? `&page=${page}` : "";
  const url = API + "/" + routeScopeFor(urlParams) + SEARCH_ALL_PATH + SEARCH_QUERY + query + pageString;

  axios
    .get(url)
    .then(function({ data }) {
      const newState = {
        aggregations: data.aggregations,
        results: data.results,
        resultsAreLoading: false,
        totalDocs: data.total_docs,
        tags: data.tags,
        offices: data.offices,
        staticData: data.static_data
      };
      callback(newState);
    })
    .catch(function(error) {
      console.error('Error', error)
      const newState = {
        error: true,
        resultsAreLoading: false
      };
      callback(newState);
    });
};

export const requestWidgets = (urlParams, callback) => {
  const { query, page } = urlParams;
  const pageString = page > 1 ? `&page=${page}` : "";
  const url = API + "/" + routeScopeFor(urlParams) + WIDGETS_PATH + SEARCH_QUERY + query + pageString;
  axios.get(url).then(function({ data }) {
    const newState = {
      widgets: { ...data, for: query },
      widgetsAreLoading: false
    };
    callback(newState);
  });
};

export const requestArticles = (urlParams, callback) => {
  const { query, page } = urlParams;
  const pageString = page > 1 ? `&page=${page}` : "";
  const url = API + "/" + routeScopeFor(urlParams) + SEARCH_ARTICLES_PATH + SEARCH_QUERY + query + pageString;
  axios
    .get(url)
    .then(function({ data }) {
      const newState = {
        results: data.results,
        resultsAreLoading: false
      };
      callback(newState);
    })
    .catch(function(error) {
      console.error('Error', error)
      const newState = {
        error: true,
        resultsAreLoading: false
      };
      callback(newState);
    });
};

export const requestArticlesWithAggregations = (urlParams, callback) => {
  const { query, page } = urlParams;
  const pageString = page > 1 ? `&page=${page}` : "";
  const routeScope = routeScopeFor(urlParams)
  const articlesUrl = API + "/" + routeScope + SEARCH_ARTICLES_PATH + SEARCH_QUERY + query + pageString;
  const allUrl = API + "/" + routeScope + SEARCH_ALL_PATH + SEARCH_QUERY + query + pageString;

  axios
    .all([ axios.get(allUrl), axios.get(articlesUrl) ])
    .then(
      axios.spread(function(allResults, articlesResults) {
        // Both requests are now complete
        const newState = {
          results: articlesResults.data.results,
          aggregations: allResults.data.aggregations,
          totalDocs: allResults.data?.aggregations?.articles?.doc_count || 0,
          resultsAreLoading: false
        };
        callback(newState);
      })
    )
    .catch(function(error) {
      console.error('Error', error)
      const newState = {
        error: true,
        resultsAreLoading: false
      };
      callback(newState);
    });
};

export const requestNextPage = (searchType, urlParams, callback, oldState) => {
  const { query, page, professionalsWidgetFilters, makeTwoRequests } = urlParams;
  let professionalsWidgetParams = {}
  const pageString = !!page ? `&page=${page}` : "";
  const routeScope = routeScopeFor(urlParams)
  let url = "";
  let widgetUrl = ""

  switch (searchType) {
    case 'articles':
      url = API + "/" + routeScope + SEARCH_ARTICLES_PATH + SEARCH_QUERY + query + pageString
      break
    case 'all':
      url = createUrl(urlParams, SEARCH_ALL_PATH)
      if (makeTwoRequests) {
        const productWidgetParams = { ...urlParams, page }
        widgetUrl = createUrl(productWidgetParams, WIDGETS_PATH)
      }
      break
    case 'projects':
      const baseUrl = searchType === ALL ? SEARCH_ALL_PATH : SEARCH_PROJECTS_PATH
      url = createUrl(urlParams, baseUrl)
      if (makeTwoRequests) {
        professionalsWidgetParams = { ...urlParams, filters: professionalsWidgetFilters, page: 1}
        widgetUrl = createUrl(professionalsWidgetParams, SEARCH_PROFESSIONALS_PATH)
      }
      break
    case 'products':
      url = createUrl(urlParams, SEARCH_PRODUCTS_PATH)
      break
    case 'professionals':
      url = createUrl(urlParams, SEARCH_PROFESSIONALS_PATH)
      break
    case 'images':
      url = createUrl(urlParams, SEARCH_IMAGES_PATH)
      break
    case 'article-archive': 
      url = createUrl(urlParams, ARTICLE_ARCHIVE_PATH)
      break
    default:
      url = API + "/" + routeScope + SEARCH_ALL_PATH + SEARCH_QUERY + query + pageString;
      break
  }

  if (makeTwoRequests) {
    axios
      .all([ axios.get(url), axios.get(widgetUrl) ])
      .then(
        axios.spread(function(data, widgetsResults) {
          // Both requests are now complete
          const { results } = data.data
          const newState = {
            ...oldState,
            items: oldState.lastSearchType === searchType ? oldState.items.concat(results) : results,
            initialLoad: false,
            hasMore: results?.length === 18,
            professionalsWidgetData: searchType === PROJECTS && widgetsResults.data.results,
            productsWidget: [...oldState.productsWidget, ...([widgetsResults.data?.['products']?.results] || []) ],
            widgetsResults: widgetsResults.data
          };
          callback(newState);
        })
      )
  } else {
    axios.get(url).then(function({ data }) {
      // handle success
      const { results } = data
      const newState = {
        ...oldState,
        items: oldState.lastSearchType === searchType ? oldState.items.concat(results) : results,
        oldItems: oldState.items,
        newItems: results,
        initialLoad: false,
        hasMore: results.length === 18
      };
      callback(newState);
    });
  }
};

export const requestFolders = async (params, callback) => {
  const { query, page } = params
  const pageString = !!page ? `&page=${page}` : ""
  const urlFolder = `/search/api/v1/${routeScopeFor(params)}/folders?q=${query}${pageString}`
  let hasMore = false
  axios
  .get(urlFolder)
  .then(function({ data }) {
    if(data.results) {
      const newState = {
        aggregations: data.aggregations,
        results: data.results,
        resultsAreLoading: false,
        totalDocs: data.total_docs
      }
      callback(newState);
    } else {
      const newState = { error: true, resultsAreLoading: false, hasMore }
      callback(newState)
    }
  }).catch(function(error) {
    console.error('Error', error)
    const newState = { error: true, resultsAreLoading: false, hasMore }
    callback(newState)
  });
}

export const requestCachedFolders = async (params, callback) => {
  const { pageString, currentPage } = params
  try {
    let hasMore = true
    const url = `${API}/${routeScopeFor(params)}${SEARCH_CACHED_FOLDERS_PATH}${pageString}`
    const response = await fetch(url)
    const { folders } = await response.json()
    if (currentPage >= MAX_CACHED_PAGES || folders.length < MYAD_FOLDER_PER_PAGE) {
      hasMore = false
    }
    const newState = {
      aggregations: EMPTY_OBJECT,
      results: folders,
      resultsAreLoading: false,
      hasMore
    }
    callback(newState)
  } catch (error) {
    console.error('Error', error)
    const newState = { error: true, resultsAreLoading: false }
    callback(newState)
  }
}

export const requestWidgetFolders = (titles = "", site = "us", callback, errorCallback) => {
  const url = MYAD_FOLDER_IMAGES + "?folder_names=" + titles + "&site=" + site;
  axios
    .get(url)
    .then(function({ data }) {
      const folders = data.folders;
      if (folders.length > 1) {
        const newState = {
          folders
        };
        callback(newState);
      } else {
        errorCallback();
      }
    })
    .catch(function(error) {
      errorCallback();
    });
};

export const requestRecommendedProducts = (site = 'us', geoIp, token, callback, errorCallback) => {
  const device = window.innerWidth >= 1040 ? 'desktop' : 'mobile'
  const url = `${window.NEUFERT_AJAX_URL}/${site}/widgets/interesting_products?token=${token}&geoip=${geoIp}&ad_medium=gallery&amount=5&device=${device}`;
  axios
    .get(url)
    .then(function({ data }) {
      callback(data)
    })
    .catch(function(error) {
      errorCallback()
    })
}

export const searchOffices = (scope = 'us', query, filters, callback, isImageSearch) => {
  let urlOffices = `/search/api/v1/${scope}/office/offices/${query}${filters}`
  isImageSearch && (urlOffices += '?index=medias')

  axios
    .get(urlOffices)
    .then(function({ data }) {
      callback(data.results)
    })
    .catch(function(error) {
      console.error('Error', error)
      callback([])
    })
}
